import { withDateFormat } from '@utils/date-time'
import { nthNumber } from '@utils/strings'
import { useMemo } from 'react'

export function useFormattedDate(
  date: Date | string | null | undefined,
  formatString: string,
  timezone?: string
): string | null {
  return useMemo(
    () => (!date ? null : withDateFormat(date, formatString, timezone)),
    [date, formatString, timezone]
  )
}

export function useDisplayDayTime(
  date: Date | string | null | undefined,
  formats?: { day?: string; time?: string },
  timezone?: string
) {
  const { day: dayFormat = 'ccc, LLL d', time: timeFormat = 'h:mm a' } = formats ?? {}
  const formattedDay = useFormattedDate(date, dayFormat, timezone)
  const formattedTime = useFormattedDate(date, timeFormat, timezone)

  return {
    day: formattedDay,
    dateSuffix: date ? nthNumber(Number(withDateFormat(date, 'd'))) : null,
    time: formattedTime,
  }
}
